import { createFileRoute } from "@tanstack/react-router"
import { AdminTracePage } from "./-TraceVideoIdPage"

export const Route = createFileRoute("/admin/trace/$videoId")({
  component: AdminTracePage,
})
